/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {QueryTopicByDisplayDateRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {QueryTopicByDisplayDateResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const queryTopicByDisplayDate = (request:QueryTopicByDisplayDateRequest, options?: CashRequestOptions) => post<QueryTopicByDisplayDateRequest, QueryTopicByDisplayDateResponse>("/2.0/cash/query-topic-by-display-date", request, {...options, rejectOnError: true })